import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/sonstige-antraege/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="OtherRequests"
      returnRoute="/auswahlfelder/otherRequests"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const OtherRequestsRoute = Route;
